import { ATTACH_PRODUCTS } from 'actions/productDetailsActions';
export default function productAttachReducer(state = {}, action) {
    switch (action.type) {
        case ATTACH_PRODUCTS:
            return Object.assign({}, state, {
                data: action.data
            });
        default:
            return state;
    }
}
